import useSinglePlaylists from '@api/hooks/single-youtube-course/useSinglePlaylists';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import BreadCrumbs from 'aquilla/core/molecules/Breadcrumbs';
import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import { Spacings, Fonts } from '@styles/index';
import styled from '@emotion/styled';
import CourseList from './CourseList';
import CourseCard from './CourseCard';
import TabList from './TabList';
import { getSingleYoutubeCourseBreadcrumbs } from './utils';

const StyBreadCrumbs = styled(BreadCrumbs)`
  margin-bottom: ${Spacings.SPACING_6B};
`;

const SingleCoursePageWrapper = styled.div`
  grid-column: 1 / -1;
`;

const CourseTypeTitle = styled(H2)`
  margin-bottom: ${Spacings.SPACING_10};
`;

const CourseTypeSubTitle = styled(P1)`
  font-weight: ${Fonts.LIGHT};
  font-size: ${Fonts.P1};
  color: var(--color-i-gray-13);
  margin-bottom: ${Spacings.SPACING_20};
`;

const SingleCoursePage = ({ goalUID }) => {
  const { singlePlaylists, size, setSize } = useSinglePlaylists(goalUID);
  const { goalInfo } = useGoalInfo(goalUID);

  const renderCourses = (course) => (
    <CourseCard key={course?.id} course={course} goalUID={goalUID} />
  );

  return (
    <SingleCoursePageWrapper>
      <TabList goalUID={goalUID} />
      <StyBreadCrumbs fragments={getSingleYoutubeCourseBreadcrumbs(goalInfo)} />
      <CourseTypeTitle>Popular classes</CourseTypeTitle>
      <CourseTypeSubTitle>
        Classes on Important topics by top educators
      </CourseTypeSubTitle>
      <CourseList
        goalUID={goalUID}
        renderCourses={renderCourses}
        size={size}
        setSize={setSize}
        playlists={singlePlaylists}
      />
    </SingleCoursePageWrapper>
  );
};

export default SingleCoursePage;
